import { ge } from '../../utils/semver';
export var name = 'visible';
export var handle = function (env) {
    return env.isInHotsoon ? 'H5_visible' : 'visible';
};
export var supports = function (env) {
    return env.isInToutiao || (env.isInHotsoon && ge(env.appVersion, '3.8.0'));
};
